module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-ExtraBoldItalic-834e159e.ttf";